module.exports = __webpack_public_path__ + "static/media/camera.ee237f45.svg";